import { render, staticRenderFns } from "./returnNotice.vue?vue&type=template&id=ee355440&scoped=true&"
import script from "./returnNotice.vue?vue&type=script&lang=js&"
export * from "./returnNotice.vue?vue&type=script&lang=js&"
import style0 from "./returnNotice.vue?vue&type=style&index=0&id=ee355440&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee355440",
  null
  
)

export default component.exports